/**
 * Các phán quyết thuần của việc "cài ứng dụng vào máy" (docs/13-tasks/01-ui-chrome.md#17 §3).
 *
 * Trình duyệt quyết định RẤT nhiều thứ ở đây, nên phần hàm thuần chỉ giữ đúng hai điều một ca
 * test đo được: trang này ĐANG chạy như ứng dụng đã cài hay chưa, và người dùng có nên thấy nút
 * "Cài ứng dụng" hay không. Phần chạm `navigator` / sự kiện nằm ở hooks/useInstallPrompt.ts.
 */

/** Nhãn của nút — một chỗ duy nhất, để ca test và giao diện không lệch nhau. */
export const INSTALL_LABEL = 'Cài ứng dụng';

/** Tên ứng dụng khi đã cài. PHẢI khớp `name` trong public/manifest.webmanifest (có ca gác). */
export const APP_NAME = 'TT Vessels';

/**
 * Trang đang chạy trong khung ứng dụng đã cài?
 *
 * Hai phép đo, vì hai hệ trả lời khác nhau: Chrome/Edge/Android đặt `display-mode: standalone`,
 * còn Safari trên iOS chỉ đặt `navigator.standalone` (một cờ riêng của Apple, không có trong
 * chuẩn). Thiếu phép thứ hai thì iPhone đã cài vẫn bị mời cài lại.
 *
 * @param matchesStandalone kết quả của `matchMedia('(display-mode: standalone)').matches`
 * @param iosStandalone giá trị `navigator.standalone` (undefined ở nơi không phải iOS Safari)
 */
export function isInstalled(
  matchesStandalone: boolean,
  iosStandalone: boolean | undefined,
): boolean {
  return matchesStandalone || iosStandalone === true;
}

/**
 * Có hiện nút "Cài ứng dụng" không?
 *
 * Chỉ hiện khi trình duyệt ĐÃ đưa lời mời cài (`beforeinstallprompt` đã bắn, tức `canPrompt`)
 * và trang chưa chạy trong khung đã cài. Không tự vẽ nút khi trình duyệt chưa mời: bấm vào sẽ
 * không có gì xảy ra, và một nút chết còn tệ hơn không có nút.
 */
export function shouldOfferInstall(canPrompt: boolean, installed: boolean): boolean {
  return canPrompt && !installed;
}
